import React from "react"
import styled from "styled-components"
import SocialNetwork from "../SocialNetwork"

const ListTitle = styled.div`
  text-transform:uppercase;
  font-weight:600;
  margin-bottom:10px;
  font-size:20px;
  line-height:30px;
`

const ListInfo = styled.div`
  margin-bottom:25px;
`
const ListItemInfo = styled.div`
  display:flex;
  flex-wrap:nowrap;
  align-items: self-start;
  color:#fff;    
  font-size:16px;
  line-height:26px;
  a{
    position:relative;
    display:inline-block;
    color:#fff;
    &:hover{
      color:#E9242A;
    }
  }
  + .list-item{
    margin-top:5px;
  }
`


const AddressList = () => {
  return (
    <>
    <ListInfo className="list-info">
      <ListTitle className="list-title">Office Address</ListTitle>
      <ListItemInfo className="list-item">
        <a className="text" href="https://maps.app.goo.gl/u5fHULcqkv4MPDzC6" target="_blank">EMB Metal Buildings, LLC, <br />340 Centennial Drive Heyburn, Idaho 83336</a>
      </ListItemInfo>
    </ListInfo>
    <ListInfo className="list-info">
      <ListItemInfo className="list-item">
        <span className="text">Call Us: <a href="tel:2085721441" aria-label="phone number">(208) 572-1441</a></span>
      </ListItemInfo>
      <ListItemInfo className="list-item">
        <span className="text">Toll Free: <a href="tel:18335442957" aria-label="phone number">1-833-544-2957</a></span>
      </ListItemInfo>
      <ListItemInfo className="list-item">
        <span className="text">Email: <a href="mailto:sales@embmetalbuildings.com">sales@embmetalbuildings.com</a></span>
      </ListItemInfo>
    </ListInfo>
    <ListInfo className="list-info">
      <SocialNetwork />
    </ListInfo>
    </>
  )
}

export default AddressList